export enum ContentLayout {
  LAYOUT1 = 'content_layout1',
  LAYOUT2 = 'content_layout2',
  LAYOUT3 = 'content_layout3',
  LAYOUT4 = 'content_layout4',
  LAYOUT5 = 'content_layout5',
  LAYOUT6 = 'content_layout6',
  LAYOUT7 = 'content_layout7',
  LAYOUT8 = 'content_layout8',
  LAYOUT9 = 'content_layout9',
  LAYOUT10 = 'content_layout10',
  LAYOUT11 = 'content_layout11',
  LAYOUT12 = 'content_layout12',
  LAYOUT13 = 'content_layout13',
}
